export const sharedToolbarListStyles = {
  containerPaper: {
    mb: 2,
    backgroundColor: '#fafafa',
  },
  mainRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: { xs: 'stretch', md: 'center' },
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: 1, md: 0 },
    mt: 2
  },
  leftSection: {
    display: 'flex',
    gap: 1,
    alignItems: 'center',
    flexWrap: 'wrap',
    flex: 1,
    minWidth: 0,
  },
  searchField: {
    width: { xs: '100%', sm: 360, md: 420, lg: 520 },
    minWidth: { xs: '100%', sm: 320 },
    '& .MuiOutlinedInput-root': {
      borderRadius: 0.5,
      height: '30px',
      fontSize: '0.875rem',
      '& fieldset': {
        borderColor: '#d1d5db',
      },
      '&:hover fieldset': {
        borderColor: '#9ca3af',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
      },
    },
    '& .MuiInputBase-input': {
      padding: '6px 12px',
    },
  },
  advancedSearchButton: {
    borderRadius: 0.5,
    textTransform: 'none',
    fontWeight: 500,
    minHeight: '22px !important',
    minWidth: 'auto !important',
    padding: '4px 12px !important',
    height: '28px !important',
    borderColor: '#d1d5db',
    marginLeft: { xs: 0, sm: '10px' },
    color: '#374151',
    '&:hover': {
      borderColor: '#9ca3af',
      backgroundColor: '#f9fafb',
    },
  },
  advancedSearchButtonActive: {
    borderRadius: 0.5,
    textTransform: 'none',
    fontWeight: 500,
    minHeight: '22px !important',
    minWidth: 'auto !important',
    padding: '4px 12px !important',
    height: '28px !important',
    borderColor: '#d1d5db',
    marginLeft: { xs: 0, sm: '10px' },
    color: '#374151',
    backgroundColor: '#f3f4f6',
    '&:hover': {
      borderColor: '#9ca3af',
      backgroundColor: '#f9fafb',
    },
  },
  rightSection: {
    display: 'flex',
    gap: 2,
    flexWrap: 'wrap',
    justifyContent: { xs: 'flex-start', md: 'flex-end' },
  },
  actionIconButtonBase: {
    p: 0,
  },
  searchAdornmentIcon: {
    fontSize: '1rem',
    color: '#6b7280',
  },
  orderActionIconButton: {
    borderRadius: 0.5,
    border: '1px solid #d1d5db',
    minHeight: '24px !important',
    minWidth: '24px !important',
    padding: '0px !important',
    height: '24px !important',
    width: '24px !important',
    color: '#374151',
    '&:hover': {
      borderColor: '#9ca3af',
      backgroundColor: '#f9fafb',
    },
    '&:disabled': {
      borderColor: '#e5e7eb',
      color: '#9ca3af',
      backgroundColor: '#f9fafb',
    },
  },
  successActionIconButton: {
    borderRadius: 0.5,
    border: '1px solid #10b981',
    minHeight: '24px !important',
    minWidth: '24px !important',
    padding: '0px !important',
    height: '24px !important',
    width: '24px !important',
    color: 'white',
    backgroundColor: '#10b981',
    '&:hover': {
      backgroundColor: '#059669',
      borderColor: '#059669',
    },
    '&:disabled': {
      borderColor: '#a7f3d0',
      color: '#ecfdf5',
      backgroundColor: '#6ee7b7',
    },
  },
  orderDeleteIconButton: {
    borderRadius: 0.5,
    border: '1px solid #d1d5db',
    minHeight: '24px !important',
    minWidth: '24px !important',
    padding: '0px !important',
    height: '24px !important',
    width: '24px !important',
    color: '#d32f2f',
    '&:hover': {
      borderColor: '#f44336',
      backgroundColor: '#ffebee',
    },
  },
  orderTrashIconButton: {
    borderRadius: 0.5,
    border: '1px solid #d1d5db',
    minHeight: '30px !important',
    minWidth: '30px !important',
    padding: '0px !important',
    height: '30px !important',
    width: '30px !important',
    color: '#6b7280',
    '&:hover': {
      borderColor: '#9ca3af',
      backgroundColor: '#f9fafb',
    },
  },
  orderToolbarActionIcon: {
    fontSize: '1.1rem',
  },
  orderConfigIconButton: {
    borderRadius: 0.5,
    border: '1px solid #93c5fd',
    minHeight: '24px !important',
    minWidth: '24px !important',
    padding: '0px !important',
    height: '24px !important',
    width: '24px !important',
    color: '#1d4ed8',
    backgroundColor: '#eff6ff',
    '&:hover': {
      borderColor: '#60a5fa',
      backgroundColor: '#dbeafe',
    },
  },
  orderTextActionButton: {
    borderRadius: 0.5,
    textTransform: 'none',
    fontWeight: 500,
    minHeight: '22px !important',
    minWidth: 'auto !important',
    padding: '4px 12px !important',
    height: '30px !important',
    borderColor: '#d1d5db',
    color: '#374151',
    '&:hover': {
      borderColor: '#9ca3af',
      backgroundColor: '#f9fafb',
    },
  },
  trashIconButton: {
    color: '#6b7280',
    '&:hover': {
      backgroundColor: '#f9fafb',
    },
  },
  deleteIconButton: {
    color: '#d32f2f',
    '&:hover': {
      backgroundColor: '#ffebee',
    },
  },
  toolbarActionIcon: {
    fontSize: '1.6rem',
  },
  deleteButton: {
    borderRadius: 0.5,
    textTransform: 'none',
    fontWeight: 'bold',
    minHeight: '22px !important',
    minWidth: 'auto !important',
    padding: '4px 12px !important',
    height: '30px !important',
    borderColor: '#d1d5db',
    color: '#d32f2f',
    '&:hover': {
      borderColor: '#f44336',
      backgroundColor: '#ffebee',
    },
  },
  companyAutocomplete: {
    width: 240,
    '& .MuiOutlinedInput-root': {
      borderRadius: 0.5,
      height: '30px',
      fontSize: '0.875rem',
      backgroundColor: 'white',
      '& fieldset': {
        borderColor: '#d1d5db',
      },
      '&:hover fieldset': {
        borderColor: '#9ca3af',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
      },
    },
  },
  advancedFiltersContainer: {
    mt: 2,
    pt: 2,
    borderTop: '1px solid #e5e7eb',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  filterSummaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 1,
  },
  filterSummaryText: {
    fontSize: '0.813rem',
    color: '#6b7280',
  },
  resetFilterButton: {
    textTransform: 'none',
  },
  compactSelect: {
    minWidth: 140,
    '& .MuiOutlinedInput-root': {
      borderRadius: 0.5,
      height: '30px',
      fontSize: '0.875rem',
      backgroundColor: 'white',
      '& fieldset': {
        borderColor: '#d1d5db',
      },
      '&:hover fieldset': {
        borderColor: '#9ca3af',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
      },
    },
  },
  wideCompactSelect: {
    minWidth: 220,
    '& .MuiOutlinedInput-root': {
      borderRadius: 0.5,
      height: '30px',
      fontSize: '0.875rem',
      backgroundColor: 'white',
      '& fieldset': {
        borderColor: '#d1d5db',
      },
      '&:hover fieldset': {
        borderColor: '#9ca3af',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
      },
    },
  },
  bulkCreateButton: {
    borderRadius: 0.5,
    textTransform: 'none',
    fontWeight: 600,
    minHeight: '22px !important',
    minWidth: 'auto !important',
    padding: '4px 12px !important',
    height: '30px !important',
    borderColor: '#86efac',
    color: '#166534',
    backgroundColor: '#ecfdf5',
    '&:hover': {
      borderColor: '#4ade80',
      backgroundColor: '#dcfce7',
    },
  },
  successActionButton: {
    backgroundColor: '#10b981',
    borderRadius: 0.5,
    textTransform: 'none',
    fontWeight: 600,
    minHeight: '22px !important',
    minWidth: 'auto !important',
    padding: '4px 12px !important',
    height: '30px !important',
    boxShadow: '0 1px 3px 0 rgba(16, 185, 129, 0.3)',
    '&:hover': {
      backgroundColor: '#059669',
      boxShadow: '0 4px 6px -1px rgba(16, 185, 129, 0.3)',
    },
  },
};
